import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      tenants: {
        Row: {
          id: string;
          name: string;
          slug: string;
          logo_url: string | null;
          brand_color: string;
          tagline: string | null;
          email: string | null;
          phone: string | null;
          website: string | null;
          address: string | null;
          city: string | null;
          country: string | null;
          timezone: string;
          currency: string;
          iata_code: string | null;
          license_number: string | null;
          founded_year: string | null;
          plan: string;
          status: string;
          trial_ends_at: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: Partial<Database['public']['Tables']['tenants']['Row']> & { name: string; slug: string };
        Update: Partial<Database['public']['Tables']['tenants']['Row']>;
      };
      profiles: {
        Row: {
          id: string;
          tenant_id: string | null;
          full_name: string | null;
          email: string | null;
          phone: string | null;
          avatar_url: string | null;
          role: string;
          is_active: boolean;
          last_login_at: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: Partial<Database['public']['Tables']['profiles']['Row']> & { id: string };
        Update: Partial<Database['public']['Tables']['profiles']['Row']>;
      };
    };
  };
};
